import styled from "styled-components";
import {FIELD_TYPE_INFO, FieldType} from "../../../Types";
import {getReadableTextColor} from "../../filters/FilterMultiMapValue";


type FieldTypeViewI = { fieldType: FieldType };
export default function FieldTypeView({fieldType}: FieldTypeViewI) {

    const color = FIELD_TYPE_INFO[fieldType].color;
    return <Container style={{background: color, color: getReadableTextColor(color)}}>
        {FIELD_TYPE_INFO[fieldType].description}
    </Container>
}


const Container = styled.div`
    padding: .2rem .4rem;
    border-radius: .2rem;
    font-size: 1rem;
`
